import React from 'react'

type LayoutProps = {
  children: React.ReactNode
  className?: string
}

const Layout = ({ children, className }: LayoutProps) => {
  return (
    <div className={className ?? 'u-bg-light-gray u-pt-64 u-pb-64'}>
      <div className="container">{children}</div>
    </div>
  )
}

export default Layout
